import dayjs from "dayjs";

export const getDayTimeRange = (datetime: string): [Date, Date] => {
  return [
    dayjs(datetime).startOf("day").toDate(),
    dayjs(datetime).endOf("day").toDate(),
  ];
};
